import { graphql } from "gql.tada";

export const DescriptionFillSectionById = graphql(`
  query DescriptionFillSectionById(
    $locale: String
    $preview: Boolean
    $id: String!
  ) {
    descriptionFillSection(id: $id, preview: $preview, locale: $locale) {
      ...DescriptionFillSectionFragment
    }
  }

  fragment DescriptionFillSectionFragment on DescriptionFillSection {
    titleQuestion
    fillDescription: description
  }
`);
